// src/pages/employer/ComingSoon.jsx
// Shared placeholder for navigation entries that do not yet have a page.

import React from 'react';
import { Clock } from 'lucide-react';

export const ComingSoon = ({ title }) => (
  <div className="page-content" style={{ padding: '24px' }}>
    <div className="page-header">{title}</div>
    <div style={{
      marginTop: 32, padding: '48px 24px',
      background: 'white', border: '1px solid var(--border)', borderRadius: 8,
      display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12,
      color: 'var(--text-muted)',
    }}>
      <Clock size={36} />
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text-mid)' }}>Coming soon…</div>
    </div>
  </div>
);
